export const iconFontAwesomeDesignSwatchbook = (
	<i className="fa-solid fa-swatchbook"></i>
);
